"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = setItem;

function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {// ignore
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/init/internal/localStorage.js
// module id = 598
// module chunks = 209 210 211 212 213